// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","328":"admin","443":"about"}[chunkId] + "." + {"177":"3ba0bb8a","328":"e8381f71","443":"4eb9d407"}[chunkId] + ".js";
};